import { gql } from '@apollo/client';

export default gql`
  mutation pushToast($toast: ToastInput!) {
    pushToast(toast: $toast) @client
  }
`;
